// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2G4fk","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1llqY"};